import axios from "axios";
import type { AxiosResponse } from "axios";
import GetSign from '@tencent/wand_lib_intel_sign'
import { getLang } from "@/utils/tools";
import LOGIN from "@/utils/login";
import { account_type } from "@/utils/const";
import { appendScript } from "@/utils/tools";
import { i18n } from "@/main";
export const request = axios.create({
	baseURL: "",
	timeout: 40000, // 设置超时时长
});
const combineLogin = async (loginParam: Record<string, any>, needLogin: boolean) => {
	// 检查登录态
	const logined = await LOGIN.checkLogin();
	if (logined) {
		return LOGIN.info();
	} 
	if (needLogin) {
		loginPage(loginParam);
	}
	return false;
}
async function loginPage(loginParam: Record<string, any>) {
	try {
		const result = await LOGIN.showLogin({
			...loginParam,
		});
		if (!result) return;
		window.location.reload();
	} catch (e) {
		console.log("登录模块需要先在模板中初始化", e);
	}
}
const joinSearchParams = (searchA: URLSearchParams, searchB: URLSearchParams) => {
		if (!searchA) return searchB;
		if (!searchB) return searchA;
		for (const [key, value] of Array.from(searchA.entries())) {
			searchB.append(key, value);
		}
  return searchB;
};
request.interceptors.request.use(
	async (rawConfig) => {
		const {
      checkLogin = true,
      needLogin = true,
      loginParam = {}, // 登录配置项
      ...resetPostData // 剩余的是post请求的真实参数
    } = rawConfig.data;
		if (!checkLogin) {
			const newconfig = GetSign({
			// const newconfig = ({
				...rawConfig,
				data: resetPostData,
			});
			return newconfig;
		}
		const res = await combineLogin(loginParam, needLogin);
		if (res === false) {
			// 未登录
			throw new axios.Cancel("not login,cancel request");
		}
		try {
			const result = new URLSearchParams(res || {});
			const { origin, pathname, searchParams } = new URL(rawConfig.url!);
			const fullSearch = joinSearchParams(result, searchParams);
			fullSearch.append("account_type", account_type);
			fullSearch.append("lang_type", getLang());
			const fullPath = `${origin}${pathname}?${fullSearch.toString()}`;
			const newconfig = GetSign({
				// const newconfig = ({
				...rawConfig,
				url: fullPath,
				data: resetPostData,
			});
			return newconfig;
		} catch (error) {
			throw new axios.Cancel(error as string);
		}
	},
	(err) => {
		const { response } = err;
		if (response) {
			checkStatus(response);
		}
		return Promise.reject(err);
	}
)
request.interceptors.response.use(
	async (res) => {
		if (res.status === 200) {
			checkBackendStatus(res);
			return Promise.resolve(res);
		}
		checkStatus(res);
		return Promise.reject(res);
	},
	(err) => {
		const { message: msg, name } = err;
		window.showTips(`${name}: ${msg}`)
		return Promise.reject(err);
	}
);

const checkStatus = (response: AxiosResponse) => {
	if (response.status >= 200 && response.status < 300) {
		return response;
	}
	const errortext = i18n.t('networkError');
	window.showTips(errortext as string)
	return response;
};
const BackendErroCode = {
	// BaseSystemError 增加投票系统错误
	// BaseSystemError = 508001
	508001: 'BaseSystemError',
	// BaseDayLimit 增加投票今日数量达上线
	// BaseDayLimit = 508003
	508003: 'VoteDelNumNotEnough',
	// BaseTotalLimit 增加投票总体数量达上线
	// BaseTotalLimit = 508004
	508004: 'VoteDelNumNotEnough',

	// VoteDayLimit 扣除投票机会已达上限
	// VoteDayLimit = 509002
	509002: 'VoteDelNumNotEnough',

	// VoteTotalLimit 扣除投票机会达总体上限
	// VoteTotalLimit = 509003
	509003: 'VoteDelNumNotEnough',
	// VoteDelNumNotEnough 投票机会不足
	// VoteDelNumNotEnough = 509006
	509006: 'VoteDelNumNotEnough',
	// 今日已签到
	512001: 'HasSignedToday',
	// 签到天数不足
	503001: 'SignedDayNotEnough',
	// RoleInfoNotSaved 未保存角色信息
	// RoleInfoNotSaved = 601004
	601004: 'RoleInfoNotSaved',
	// NoRoleInfo 没有查到角色信息
	// NoRoleInfo = 601008
	601008: 'NoRoleInfo',  // 界面提示
	// RoleInfoHasSaved 已保存角色信息
	// RoleInfoHasSaved = 601009
	601009: 'RoleInfoHasSaved',
	// FlowHasNotBegin = 200006 时间未开始
	200006: 'FlowHasNotBegin',
	// FlowHasEnd = 200007 事件已结束
	200007: 'FlowHasEnd',
	210002: "FlowHasNotBegin",
	// MiddlewareFlowLock = 210200 用户多次请求同一个接口
	210200: 'MiddlewareFlowLock',
	400013: 'GetGiftLimit',
	default: 'serverError',
}
const checkBackendStatus = async (response: AxiosResponse) => {
	const { data } = response;
	if (!data) {
		return;
	}
	const { msg, code } = data;
	// 登录态失效
	if (code === 300001) {
		await LOGIN.showLogin({ lang: i18n.locale })
		window.location.reload()
		return;
	}
	// 界面提示
	if (code === 601008) return;
	if (code !== 0) {
		const backendErroCode = BackendErroCode[code as keyof typeof BackendErroCode] 
		const text = i18n.t(backendErroCode) || BackendErroCode.default  || msg
		window.showTips(text)
		return;
	}
};

export const initServetime = async () => {
	const now = new Date()
	const src = `https://sg-act.playerinfinite.com/api/system/get_server_timestamp_and_update?t=` + now.getTime()
	await appendScript(src)
}
